import ApplicationComponent from "legacy/ApplicationComponent"
import LegacyButton from "legacy/LegacyButton"
import LoadingView from "legacy/LoadingView"
import Paginator from "legacy/Paginator"
import ContractTableRowV2 from "legacy/contract-groups-v2/ContractTableRowV2"
import { afterSetState, updateUrlQueryParams } from "legacy/helpers.es6"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

// Note: jQuery ($) is loaded globally

class ContractTableV2 extends ApplicationComponent {
  constructor(args) {
    super(args)
    this.state = {
      contracts: this.isPaginated() && this.props.paginatedList.items,
      page: this.isPaginated() && (this.props.paginatedList.page || 1),
      numberOfPages: this.isPaginated() && this.props.paginatedList.pageCount,
      totalContractsCount:
        this.isPaginated() && this.props.paginatedList.totalCount,
      isLoading: false,
      errorMessage: null,
    }
    this.goToPage = this.goToPage.bind(this)
    this.updateUrl = this.updateUrl.bind(this)
    this.isPaginated = this.isPaginated.bind(this)
    this.sendAllContracts = this.sendAllContracts.bind(this)
  }

  isPaginated() {
    return this.props.paginatedList !== undefined
  }

  contracts() {
    if (this.isPaginated()) {
      return this.state.contracts
    }

    return this.props.list
  }

  fetchContracts() {
    this.setState({ isLoading: true })
    $.ajax({
      url: `${this.props.contractsEndpoint}?page=${this.state.page}`,
      type: "GET",
      dataType: "json",
      contentType: "application/json",
      success: (data) => {
        this.setState({
          isLoading: false,
          contracts: data.items,
          numberOfPages: data.pageCount,
          totalSalesCount: data.totalCount,
        })
        afterSetState(this.updateUrl)
      },
      error: (data) => {
        this.setState({
          isLoading: false,
          errorMessage: data.responseJSON.error,
        })
      },
    })
  }

  sendAllContracts() {
    $.ajax({
      url: this.props.bulkSendContractsUrl,
      type: "POST",
      data: {
        contract_quotes: this.contracts().map((contract) => contract.encodedId),
      },
    })
  }

  goToPage(page) {
    this.setState({ page })
    afterSetState(() => {
      this.fetchContracts()
      this.updateUrl()
    })
  }

  updateUrl() {
    updateUrlQueryParams({ page: this.state.page })
  }

  renderActionButton() {
    switch (this.props.actionButtonType) {
      case "sendAll":
        return (
          <button
            key="sendAll"
            type="button"
            className="btn btn-tertiary btn-sm float-right"
            data-toggle="tooltip"
            data-placement="top"
            title="This will send all contracts"
            data-method="post"
            data-confirm="Are you sure you want to send all unsent contracts? This cannot be undone."
            onClick={this.sendAllContracts}
          >
            Send All
          </button>
        )
      case "resendAll":
        return (
          <button
            key="resendAll"
            type="button"
            className="btn btn-tertiary btn-sm float-right"
            data-toggle="tooltip"
            data-placement="top"
            title="This will resend all outstanding contracts"
            data-method="post"
            data-confirm="Are you sure you want to resend all outstanding contracts? This cannot be undone."
            onClick={this.sendAllContracts}
          >
            Resend All
          </button>
        )
      default:
        return null
    }
  }

  render() {
    if (this.state.isLoading) {
      return <LoadingView name="Contracts" />
    } else if (this.state.errorMessage) {
      return <p className="italics">{this.state.errorMessage}</p>
    } else if (this.contracts().length === 0) {
      return <span>Nothing to see here</span>
    } else {
      const html = _.map(this.contracts(), (contract, index) => {
        return (
          <ContractTableRowV2
            canUpdate={this.props.canUpdate}
            contactUrl={this.props.contactUrl}
            contract={contract}
            completeInHouseUrl={this.props.completeInHouseUrl}
            markContractDeclinedUrl={this.props.markContractDeclinedUrl}
            deleteContractUrl={this.props.deleteContractUrl}
            editContractUrl={this.props.editContractUrl}
            expireContractUrl={this.props.expireContractUrl}
            generatePdfEndpoint={this.props.generatePdfEndpoint}
            index={index}
            key={contract.encodedId}
            marinaName={this.props.marinaName}
            marinaSlug={this.props.marinaSlug}
            updateSendContractFlash={this.props.updateSendContractFlash}
            reservationContractUrl={this.props.reservationContractUrl}
            savedPdfEndpoint={this.props.savedPdfEndpoint}
            selectedContractId={this.props.selectedContractId}
            sendContractUrl={this.props.sendContractUrl}
            currency={this.props.currency}
          />
        )
      })
      return (
        <div>
          <table className="table-striped table-responsive table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Rate</th>
                <th>Status</th>
                <th>
                  {this.props.actionButtonType && this.props.canUpdate ? (
                    this.renderActionButton()
                  ) : (
                    <LegacyButton
                      type="tertiary"
                      className="btn-sm invisible"
                      onClick={() => {}}
                    >
                      Hidden
                    </LegacyButton>
                  )}
                </th>
              </tr>
            </thead>
            <tbody>{html}</tbody>
          </table>
          {this.state.numberOfPages > 1 && (
            <div className="flex">
              <Paginator
                page={this.state.page}
                numberOfPages={this.state.numberOfPages}
                totalItemsCount={this.state.totalContractsCount}
                goToPage={this.goToPage}
              />
            </div>
          )}
        </div>
      )
    }
  }
}

ContractTableV2.propTypes = {
  paginatedList: PropTypes.shape({
    items: PropTypes.array,
    page: PropTypes.number,
    pageCount: PropTypes.number,
    totalCount: PropTypes.number,
  }),
  list: PropTypes.array,
  canUpdate: PropTypes.bool,
  contactUrl: PropTypes.string,
  completeInHouseUrl: PropTypes.string,
  markContractDeclinedUrl: PropTypes.string,
  deleteContractUrl: PropTypes.string,
  editContractUrl: PropTypes.string,
  expireContractUrl: PropTypes.string,
  generatePdfEndpoint: PropTypes.string,
  marinaName: PropTypes.string,
  marinaSlug: PropTypes.string,
  updateSendContractFlash: PropTypes.func,
  reservationContractUrl: PropTypes.string,
  savedPdfEndpoint: PropTypes.string,
  selectedContractId: PropTypes.string,
  sendContractUrl: PropTypes.string,
  contractsEndpoint: PropTypes.string,
  bulkSendContractsUrl: PropTypes.string,
  actionButtonType: PropTypes.string,
  currency: PropTypes.string,
}

export default ContractTableV2
